import React, { PropTypes } from 'react';
import AnimateOnChange from 'react-animate-on-change';
import {CITY_BOUND_SW, CITY_BOUND_NE} from '../../../constants/places';
import Field from '../Field/Field';
import './PlaceField.less';

const inputRef = 'address_input';

class PlaceField extends Field {
  componentDidMount() {
    const {onPlaceChanged} = this.props;
    const input = this.refs[inputRef];

    //NOTE: https://developers.google.com/maps/documentation/javascript/places-autocomplete
    const autocomplete = new google.maps.places.Autocomplete(input, {
      bounds: new google.maps.LatLngBounds(CITY_BOUND_SW, CITY_BOUND_NE),
      strictBounds: true
    });

    this.placeChangedListener = autocomplete.addListener('place_changed', function() {
      if (!onPlaceChanged) {
        return;
      }

      const place = autocomplete.getPlace();
      const geometry = place.geometry;

      const address = {
        latLng: geometry ? {lat: geometry.location.lat(), lng: geometry.location.lng()} : null,
        streetAddress: input.value//place.name
      };
      onPlaceChanged(address);
    });

    this.autocomplete = autocomplete;
  }

  componentWillUnmount() {
    const {placeChangedListener} = this;
    if (placeChangedListener) {
      placeChangedListener.remove();
    }
  }

  render () {
    const {value, label, placeholder, autoFocus} = this.props;
    const {animateError} = this.state;

    return (
      <AnimateOnChange
          baseClassName="input-field text-field place-field"
          animationClassName="shake--active"
          animate={animateError}>
        {label && (<label>{label}</label>)}
        <input type="text" ref={inputRef} placeholder={placeholder} autoFocus={autoFocus} defaultValue={value}/>
      </AnimateOnChange>
    );
  }
}

PlaceField.defaultProps = {
  valid: true
};

PlaceField.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  autoFocus: PropTypes.bool,
  onPlaceChanged: PropTypes.func
};

export default PlaceField;



// WEBPACK FOOTER //
// ./src/components/common/PlaceField/PlaceField.js